// DynamicPoseComponent.js
import React from 'react';
import posed from 'react-pose';

const getDynamicPoseConfig = (selectedAnimation) => ({
  exited: selectedAnimation.exited,
  exiting: selectedAnimation.exiting,
  entered: selectedAnimation.entered,
  enter: selectedAnimation.enter,
});

export const DynamicFadingContent = ({ selectedAnimation, transitionStatus, children }) => {
  const PosedComponent = React.useMemo(() => posed.div(getDynamicPoseConfig(selectedAnimation)), [selectedAnimation]);
  return <PosedComponent pose={transitionStatus}>{children}</PosedComponent>;
};
